export default __webpack_public_path__ + "static/media/requirements-embedded@2x.742e4934.jpg";